/*
*
* File JS componente Block Tab List
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';

Swiper.use([Navigation, Pagination, A11y]);

//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-tab-list.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockTabList = () => {
    const context = document.querySelector('.block-tab-list');
    if(!context) return;

    const headerTabs = context.querySelectorAll('.block-tab-list__head a');
    const contentTabs = context.querySelectorAll('.block-tab-list__body > div');
    if(!headerTabs || !contentTabs) return;

    headerTabs.forEach(item => {

        item.addEventListener('click' , (e) => {
            e.preventDefault();
            const currentDatTab = item.getAttribute('data-tab');

            if(currentDatTab)  {
                const contentToShow = context.querySelector(`.block-tab-list__content[data-tab='${currentDatTab}']`);
                toggleContentTabs(contentToShow);
                toggleHeader(item);
            }

        })

    });

    function toggleContentTabs(showTab) {
        contentTabs.forEach(item => {
          item.classList.remove('active');
          item.classList.remove('fade-in');          
        });
        showTab.classList.add('active');

        setTimeout(() => {
          showTab.classList.add('fade-in');
        }, 50); 
    }

    function toggleHeader(showHeader)
    {

        headerTabs.forEach(item => {
            item.setAttribute('aria-selected', 'false');
            item.classList.remove('active');
        });

        showHeader.classList.add('active');
        showHeader.setAttribute('aria-selected', 'true');
    }

    // Sostituzione dell'immagine SVG nei tag IMG all'interno di headerTabs
    window.onload = function() {
        const headerTabs = document.querySelectorAll('.block-tab-list__head a');

        headerTabs.forEach(tab => {
            const img = tab.querySelector('img'); // Trova l'immagine
            const svgSrc = img.getAttribute('src'); // Ottieni il percorso dell'immagine SVG
            fetch(svgSrc) // Carica l'immagine SVG come testo
                .then(response => response.text())
                .then(svgText => {
                    const parser = new DOMParser();
                    const svgDoc = parser.parseFromString(svgText, 'image/svg+xml');
                    const svgElement = svgDoc.documentElement; // Ottieni l'elemento svg
                    svgElement.setAttribute('class', img.getAttribute('class')); // Copia le classi dall'immagine precedente
                    img.parentNode.replaceChild(svgElement, img); // Sostituisci l'immagine con l'elemento SVG
                })
                .catch(error => {
                    console.error('Errore nel caricamento dell\'SVG:', error);
                });
        });
    };


    // Parte Slider
    let slider = document.querySelectorAll('.block-tab-list .swiper-container');
    if(!slider.length) return;
    
    slider.forEach(el => {
        
        let arrowPrev = el.querySelector('.swiper-button-prev');
        let arrowNext = el.querySelector('.swiper-button-next');

        let pagination = el.querySelector('.swiper-pagination');

        let args = {
            spaceBetween: 20,
            slidesPerView: 6,
            speed: 600,
            navigation: 
            {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination: {
                el: pagination,
                type: 'progressbar',
                clickable: true,
            },
            breakpoints: {
                1024: {
                  slidesPerView: 10,
                  spaceBetween: 20,
                },
                768: {
                    slidesPerView: 5.5,
                    spaceBetween: 20,
                  },
                400: 
                {
                    slidesPerView: 3.5,
                    spaceBetween: 20,
                    loop: false,
                },
                0: {
                  slidesPerView: 2.5,
                  spaceBetween: 20,
                  loop: false,
                },
              },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };

        new Swiper(el, args);
    })
}



export default blockTabList;

//--------------------------------------------------------------------//